import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { SelectTipoEfector } from "./components/SelectTipoEfector";
import { FormIngresoEfectorDocumentacion } from "./components/FormIngresoEfectorDocumentacion";
import { limpiarTipoDocumentacionPorSubtipoEfector, traerTipoDocumentacionPorSubtipoEfector } from "../../../../actions/contrataciones/configuraciones/tipoDocumentacionPorSubtipoEfector";
import { fetchSubTipoEfectores } from "../../../../actions/tipoSubtipoEfectores";
import { traerTipoDocumentaciones } from "../../../../actions/abm/abm";

const useStyles = makeStyles({
  root: {
    marginTop: 20
  },
  rootTitulo: {
    marginTop: 20,
    color: 'white',
    marginBottom: 20
  }
});

export const TipoDocumentacionesEfectorPorSubtipoEfectorScreen = (props) => {
  const { subtipoEfectores } = useSelector((state) => state.tipoSubtipoEfectores)

  const dispatch = useDispatch();
  const classes = useStyles();

  const [idSubTipoEfector, setIdSubtipoEfector]=useState("")
  const handleChange = (event) => {
    setIdSubtipoEfector(parseInt(event.target.value))
    dispatch(traerTipoDocumentacionPorSubtipoEfector(event.target.value));
  };

  useEffect(() => {
    dispatch(fetchSubTipoEfectores());
    dispatch(traerTipoDocumentaciones(2))//Trae las documentaciones por modulo, en este caso contratos
    dispatch(limpiarTipoDocumentacionPorSubtipoEfector())
  }, [dispatch]);

  return (
    <Grid container justify="center" className={classes.root}>
      <Grid item xs={12}>
        <Grid container justify="center">
          <Grid item xs={12} md={4}>
          <SelectTipoEfector options={subtipoEfectores} handleChange={handleChange} value={idSubTipoEfector} />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography component="h3" variant="h5" align="center" className={classes.rootTitulo}>Documentación por Subtipo de Efector</Typography>

        <FormIngresoEfectorDocumentacion idSubTipoEfector={idSubTipoEfector} />
      </Grid>
    </Grid>
  );
};